import { accountSummaryV2Url } from "../api/endpoints.js";
import getFetchWrapper from "../api/getFetchWrapper.js";
const queryFnFactory = (config, keyProps) => {
  return () => {
    const fetchWrapper = getFetchWrapper(config);
    const params = new URLSearchParams({
      "cipher.accountId": keyProps.accountId
    });
    if (keyProps.accountIdType) {
      params.set("accountIdType", keyProps.accountIdType);
    }
    return fetchWrapper(`${accountSummaryV2Url}?${params}`, {
      method: "GET"
    });
  };
};
export { queryFnFactory as default };
//# sourceMappingURL=query.js.map
